import CourseDetails from './CourseDetails';

export default CourseDetails;
